export default function () {
  const widgetName = 'multiScheduleFeature';
  const widgetOpts = multiScheduleFeatureOpts;


  const sizeWind = $(window).width();
  let limitcharacters = ""
  if (sizeWind <= 425) {
    limitcharacters = 20
  } else if (sizeWind <= 768) {
    limitcharacters = 35
  } else if (sizeWind <= 1024) {
    limitcharacters = 50
  } else
    limitcharacters = 26



  $(`#${widgetName}`).append('<div class="multiFeatureContent"></div>');



  $(`#${widgetName}`).MultiScheduleFeature({
    scriptPath: widgetOpts.scriptPath
    , currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID
    , detectIpad: IPADDETECTED
    // options
    , allEventsLink: true
    , allEventsLinkText: 'All Events'
    , hasImages: true
    , imageBackground: false
    , lazyLoadImages: true
    , buyNowButton: { visible: false, text: '' }
    , moreButton: { visible: false, text: '' }
    , maxItemsVisible: 4
    , isResponsive: false
    , hasDescription: false
    , textContainer: true
    , link: 'all'
    , attributeOrder: {
      1: 'image',
      2: 'date',
      3: 'title',
      4: 'description',
      5: 'buttons'
    }
    , multiFeatureLoaded: function (data) {
      $('.all-events-btn').addClass('button');
      $('.featureItem').after('<div class="wrap-event"></div>');


      $('#multiScheduleFeature .featureItem').each(function (i) {
        // var eventDate = $(this).find($('span.featureItemDate'));
        // var datesMonth = eventDate.text().slice(0, 3);
        // var datesDay = eventDate.text().slice(4, 7).replace(',', '');
        // eventDate.text(datesMonth);
        // eventDate.append("<span>" + datesDay + "</span>");
        const itemTitle = $(this).find('.featureItemTitle');
        const characterLimit = limitcharacters;
        const itemTitleText = itemTitle.text();

        if (itemTitleText.length > characterLimit) {
          const trimmedText = itemTitleText.substring(0, characterLimit) + '...';
          itemTitle.text(trimmedText);
        }

        let urlData = data[i].URL

        // NO IMG AVAILABLE UPDATE
        const img = $(this).find('.featureItemImage img');
        const imgDataSrc = img.attr('data-src');
        if (imgDataSrc.includes('no_image_available.jpg')) {
          img.attr('src', `${FULLCLIENTTHEMEPATH}images/no_image_available.jpg`);

        }

        if (urlData == "") {
          $(this).removeAttr('href')
        }

      });
    }
  });

};

